import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const calendarYearsListRowFn = /* @__PURE__ */ createRecipe('calendar-years-list-row', {}, [])

const calendarYearsListRowVariantMap = {}

const calendarYearsListRowVariantKeys = Object.keys(calendarYearsListRowVariantMap)

export const calendarYearsListRow = /* @__PURE__ */ Object.assign(memo(calendarYearsListRowFn.recipeFn), {
  __recipe__: true,
  __name__: 'calendarYearsListRow',
  __getCompoundVariantCss__: calendarYearsListRowFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: calendarYearsListRowVariantKeys,
  variantMap: calendarYearsListRowVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, calendarYearsListRowVariantKeys)
  },
  getVariantProps: calendarYearsListRowFn.getVariantProps,
})